import type { ProgramFile } from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import { DownloadOutline } from '@eqi-investimentos/icons/web';
import { Button, Link } from '@eqi-investimentos/react';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useSendClickEvent } from '@/modules/Customer/http/client/mutations/useSendClickEvent';

export const SupplementaryMaterialCard: FC<SupplementaryMaterialCardProps> = ({
  title,
  url,
}) => {
  const { mutate: sendClickEvent } = useSendClickEvent();

  const onClickDownloadMaterial = () => {
    sendClickEvent({
      label:
        salesforceOpportunityConfig.sendClickEvent.supplementaryMaterial.label(
          window.location.pathname
        ),
    });
  };

  if (!url) return <></>;

  return (
    <Link
      download
      target="_blank"
      rel="noopener noreferrer"
      href={url}
      onClick={onClickDownloadMaterial}
    >
      <Button
        variant="outline"
        size="m"
        rightIcon={<DownloadOutline boxSize="1.5rem" color="content.brand" />}
        borderRadius="2xs"
        gap="m"
        py="l"
        px="m"
        _hover={{
          bgColor: 'action.hover.brand',
          color: 'content.alwaysLight',
          border: '1px solid transparent',
          '.chakra-icon': {
            color: 'content.alwaysLight',
          },
        }}
      >
        {title}
      </Button>
    </Link>
  );
};

type SupplementaryMaterialCardProps = Pick<ProgramFile, 'title' | 'url'>;
